import styled from '@emotion/styled';
import { ui } from '@libs/domain';
import { colors } from '@libs/ui';
import { useItemNames } from '@ps-smart-cp/ppfw-client';

const SandboxBadge = styled.div`
  display: inline-flex;
  align-items: center;
  height: 25px;
  margin-top: 7px;
  border: 2px solid ${colors.highlightRed};
  border-radius: 4px;
  box-sizing: border-box;
  overflow: hidden;
  font-size: 12px;
  font-weight: 700;
  line-height: 21px;
  color: ${colors.highlightRed};
  background-color: ${colors.white};
`;

const SandboxText = styled.span`
  padding: 0 12px;
  font-size: 11px;
  font-weight: bold;
  line-height: 1;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

function SandboxLabel() {
  const getLabelName = useItemNames(ui.labelNames);
  return (
    <SandboxBadge id="global-sandbox-label">
      <SandboxText>{getLabelName('sandbox')}</SandboxText>
    </SandboxBadge>
  );
}

export { SandboxLabel };
